import React from "react"
import { HashRouter as Router, Route, Link } from "react-router-dom"
import Master from "./master"
import New from "./new"
import GroupConv from "./detail/motifs/groupConv"
import Sequencer from "./sequence"
import Home from "./home"
import CircuitEditor from "./interfaces/circuitEditor"
import Interventions from "./interventions"

import CurveCircuit from "./circuits/curve-circuit"
import CurveDetector from "./circuits/curve-detector"
import OrientedDogs from "./circuits/oriented-dogs"
import ZoomIn from "./commentaries/zoomIn"
import Encoder from "./encoder"
import ModelOrganism from "./commentaries/modelOrganisms"
import EvaluateClaims from "./commentaries/evaluateClaims"

export default class App extends Component {
  render() {
    return (
      <Router>
        <Route path="/tools/designer" exact component={CircuitEditor} />
        <Route path="/master" exact component={Master} />
        <Route path="/" exact component={Home} />
        <Route path="/sequence" exact component={Sequencer} />
        <Route path="/new" exact component={New} />

        <Route path="/research/interventions" component={Interventions} />
        <Route path="/motifs/groupConv" component={GroupConv} />

        <Route path="/commentaries/zoom-in" component={ZoomIn} />
        <Route
          path="/commentaries/evaluate-claims"
          component={EvaluateClaims}
        />
        <Route path="/commentaries/model-organisms" component={ModelOrganism} />
        <Route path="/research/curve-detectors" component={CurveDetector} />
        <Route path="/research/oriented-dogs" component={OrientedDogs} />
        <Route path="/research/curve-circuit" component={CurveCircuit} />
        <Route path="/encoder" component={Encoder} />
      </Router>
    )
  }
}
